import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { IAddClientSchema, IClient, IClientDetailsSchema, IClientState } from './types';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';

const initialState: IClientState = {
  addClient: {},
  clients: {},
  updateClient: {},
  updateClientStatus: {},
  clientDetails: {},
  clientDetailsById: {},
};
const slice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    addClient(state, action: PayloadAction<IAddClientSchema>) {
      state.addClient.status = RequestStatus.RUNNING;
    },
    addClientSuccess(state, action: PayloadAction<IAddClientSchema>) {
      state.addClient.status = RequestStatus.SUCCESS;
      state.addClient.data = action.payload;
    },
    addClientFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addClient.status = RequestStatus.ERROR;
      state.addClient.error = action.payload;
    },
    //
    getClients(state) {
      state.clients.status = RequestStatus.RUNNING;
    },
    getClientsSuccess(state, action: PayloadAction<IClientState['clients']['data']>) {
      state.clients.status = RequestStatus.SUCCESS;
      state.clients.data = action.payload;
    },
    getClientsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.clients.status = RequestStatus.ERROR;
      state.clients.error = action.payload;
    },
    //
    updateClient(state, action: PayloadAction<any>) {
      state.updateClient.status = RequestStatus.RUNNING;
    },
    updateClientSuccess(state, action: PayloadAction<IClient>) {
      state.updateClient.status = RequestStatus.SUCCESS;
      state.updateClient.data = action.payload;
    },
    updateClientFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateClient.status = RequestStatus.ERROR;
      state.updateClient.error = action.payload;
    },
    //
    updateClientStatus(state, action: PayloadAction<any>) {
      state.updateClientStatus.status = RequestStatus.RUNNING;
    },
    updateClientStatusSuccess(state, action: PayloadAction<IClient>) {
      state.updateClientStatus.status = RequestStatus.SUCCESS;
      state.updateClientStatus.data = action.payload;
    },
    updateClientStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateClientStatus.status = RequestStatus.ERROR;
      state.updateClientStatus.error = action.payload;
    },
    //
    getClientDetails(state, action: PayloadAction<IClientDetailsSchema>) {
      state.clientDetails.status = RequestStatus.RUNNING;
    },
    getClientDetailsSuccess(state, action: PayloadAction<IClientState['clientDetails']['data']>) {
      state.clientDetails.status = RequestStatus.SUCCESS;
      state.clientDetails.data = action.payload;
    },
    getClientDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.clientDetails.status = RequestStatus.ERROR;
      state.clientDetails.error = action.payload;
    },
    //
    getClientDetailsById(state) {
      state.clientDetailsById.status = RequestStatus.RUNNING;
    },
    getClientDetailsByIdSuccess(
      state,
      action: PayloadAction<IClientState['clientDetailsById']['data']>
    ) {
      state.clientDetailsById.status = RequestStatus.SUCCESS;
      state.clientDetailsById.data = action.payload;
    },
    getClientDetailsByIdFailed(state, action: PayloadAction<IRequestFailed>) {
      state.clientDetailsById.status = RequestStatus.ERROR;
      state.clientDetailsById.error = action.payload;
    },
    //
  },
});

export default slice.reducer;
export const {
  addClient,
  addClientSuccess,
  addClientFailed,
  getClients,
  getClientsFailed,
  getClientsSuccess,
  updateClient,
  updateClientSuccess,
  updateClientFailed,
  updateClientStatus,
  updateClientStatusSuccess,
  updateClientStatusFailed,
  getClientDetails,
  getClientDetailsFailed,
  getClientDetailsSuccess,
  getClientDetailsById,
  getClientDetailsByIdFailed,
  getClientDetailsByIdSuccess,
} = slice.actions;
